import axios from 'axios'
import store from '@/store'
import router from '@/router'

const service = axios.create({
  baseURL: '/web-api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const authHeader = store.getters.getAuthHeader
    if (authHeader) {
      config.headers['Authorization'] = authHeader
    }
    return config
  },
  error => {
    console.error('请求异常：', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    // ==============================
    // ✅ 自动同步后端最新次数（从响应头读取）
    // ==============================
    const usage = response.headers['x-daily-usage']
    const limit = response.headers['x-daily-limit']
    if (usage !== undefined && limit !== undefined) {
      store.dispatch('setDailyInfo', {
        usage: Number(usage),
        limit: Number(limit)
      })
    }

    if (res.code === 200 || res.code === 0) {
      return res.data
    }

    // 错误处理
    switch (res.code) {
      case 401:
        store.commit('CLEAR_USER_INFO')
        router.replace({ path: '/login' })
        return Promise.reject(new Error(res.msg || '登录失效'))
      case 403:
        return Promise.reject(new Error(res.msg || '无权限'))
      case 404:
        return Promise.reject(new Error(res.msg || '接口不存在'))
      case 429:
        return res.code
      case 430:
        return res.code
      case 500:
        return Promise.reject(new Error(res.msg || '服务器异常'))
      default:
        return Promise.reject(new Error(res.msg || '请求失败'))
    }
  },

  error => {
    console.error('响应异常：', error)
    if (error.response?.status === 401) {
      store.commit('CLEAR_USER_INFO')
      router.replace({ path: '/login' })
    }
    return Promise.reject(error)
  }
)

export default service